import { Button, CloseButton, Divider, Flex, LoadingOverlay } from "@mantine/core";
import React from "react";
import * as yup from "yup";

import { HttpHandler } from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { Form } from "../form";
import { CheckboxField } from "../form/checkbox-field";
import { TextField } from "../form/text-field";
import { TextareaField } from "../form/textarea-field";
import { FormLayout } from "../layout";
import { itemTypeApi } from "../../apis";

const schema = yup.object({
  name: yup.string().max(255, "Хэт урт байна!").required("Заавал бөглөнө!").nullable(),
  description: yup.string().max(255, "Хэт урт байна!").required("Заавал бөглөнө!").nullable(),
});

type IFormData = {
  name: string;
  description: string;
  isPublic: boolean;
  isGoods: boolean;
  isService: boolean;
};

export function ItemTypeForm({ onCancel, action, reload }: { onCancel?: () => void; action: any; reload: () => void }) {
  const [loading, setLoading] = React.useState(false);
  const [data] = React.useState<IFormData>({
    name: "",
    description: "",
    isService: false,
    isGoods: false,
    isPublic: false,
    ...(action && action[0] === "update" ? action[1] : {}),
  });

  const onSubmit = async (value: IFormData) => {
    const data = {
      name: value.name,
      description: value.description,
      isPublic: value.isPublic,
      isGoods: value.isGoods,
      isService: value.isService,
    };

    setLoading(true);
    try {
      if (action && action[0] === "update") {
        await itemTypeApi.update(action[1].id, {
          ...data,
        });
      } else {
        await itemTypeApi.create(data);
      }

      Message.success("Таны хүсэлт амжилттай!");
      onCancel && onCancel();
      reload();
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Form validationSchema={schema} onSubmit={onSubmit} initialValues={data}>
      {({ values }) => {
        return (
          <FormLayout
            title={action && action[0] === "update" ? "Нэр төрөл засварлах" : "Нэр төрөл нэмэх"}
            subTitle="Нэр төрлийн мэдээлэл"
            my={0}
            extra={[<CloseButton key="cancel" onClick={() => onCancel && onCancel()} />]}>
            <LoadingOverlay visible={loading} />
            <Flex gap={15} direction="column">
              <Divider />
              <TextField name="name" label="Нэр" placeholder="Нэр" />
              <CheckboxField name="isGoods" label="Бараа" />
              <CheckboxField name="isService" label="Үйлчилгээ" />
              <CheckboxField name="isPublic" label="Нээлттэй" />
              <TextareaField name="description" label="Тайлбар" placeholder="Тайлбар" />
              <Divider mb={10} />
            </Flex>
            <Flex justify="space-between">
              <Button key={1} variant="default" onClick={() => onCancel && onCancel()}>
                Болих
              </Button>
              <Button key={2} type="submit">
                Хадгалах
              </Button>
            </Flex>
          </FormLayout>
        );
      }}
    </Form>
  );
}
